import i18n from "../../../../i18n";
    const IncidentID = i18n.t('manageAutomation.IncidentID');
    const FailureType = i18n.t('manageAutomation.FailureType');
    const IncidentStatus = i18n.t('manageAutomation.IncidentStatus');
    const Priority = i18n.t('manageAutomation.Priority');
    const ProcessName = i18n.t('manageAutomation.ProcessName');
    const JobID = i18n.t('manageAutomation.JobID');
    const ExpectedDuration = i18n.t('manageAutomation.ExpectedDuration');
    const ActualDuration = i18n.t('manageAutomation.ActualDuration');
    const ExecutionResource = i18n.t('manageAutomation.ExecutionResource');
    const ResourceName = i18n.t('manageAutomation.ResourceName');
    const UpdatedOn = i18n.t('manageAutomation.UpdatedOn');
    const Client = i18n.t('manageAutomation.Client');
    const Technology = i18n.t('manageAutomation.Technology');
    const IncidentURL = i18n.t('manageAutomation.IncidentURL');
    const SysId= i18n.t('manageAutomation.SysId');

const PREDICTED_ALERT_HEADERS = [
    {
      key: 'incidentId',
      header: IncidentID,
      hidden: false,
      optional: false,
      type: 'all'
    },
    {
      key: 'incidentStatus',
      header: IncidentStatus,
      hidden: false,
      optional: false,
      type: 'all'
    },
    {
      key: 'priority',
      header: Priority,
      hidden: false,
      optional: false,
      type: 'all'
    },
    {
      key: 'failureType',
      header: FailureType,
      hidden: false,
      optional: false,
      type: 'dependency'
    },
    {
      key: 'resourceName',
      header: ResourceName,
      hidden: false,
      optional: false,
      type: 'dependency'
    },
    {
      key: 'processName',
      header: ProcessName,
      hidden: false,
      optional: false,
      type: 'automata'
    },
    {
      key: 'executionResource',
      header: ExecutionResource,
      hidden: false,
      optional: false,
      type: 'automata'
    },
    {
      key: 'id',
      header: JobID,
      hidden: true,
      optional: true,
      type: 'all'
    },
    {
      key: 'expectedDuration',
      header: ExpectedDuration,
      hidden: false,
      optional: false,
      type: 'automata'
    },
    {
      key: 'actualDuration',
      header: ActualDuration,
      hidden: false,
      optional: false,
      type: 'automata'
    },

    {
      key: 'updatedOn',
      header: UpdatedOn,
      hidden: false,
      optional: false
    },
    {
      key: 'client',
      header: Client,
      hidden: true,
      optional: true,
      type: 'all'
    },
    {
      key: 'technology',
      header: Technology,
      hidden: true,
      optional: true,
      type:'all'
    },
    {
        key: 'incidentURL',
        header: IncidentURL,
        hidden: true,
        optional: false
    },
    {
      key: 'sysId',
      header: SysId,
      hidden: true,
      optional: false
    }
  ];
  export default PREDICTED_ALERT_HEADERS;